module.exports = __webpack_public_path__ + "img/Group2.d88b5ec8.png";